import { User, Box, Globe2, Layers, Building2 } from 'lucide-react';
import type { EntityType } from '../lib/types';

const map = {
  Person: User,
  Product: Box,
  Geography: Globe2,
  Segment: Layers,
  Company: Building2,
};

export function EntityTypeIcon({ type, size = 14 }: { type: EntityType; size?: number }) {
  const Icon = map[type] ?? Box;
  return <Icon size={size} strokeWidth={1.5} aria-hidden="true" />;
}
